import { gql } from "@apollo/client";

const GET_MORE_CLASSES = gql`
  query GetMoreClasses($lessonId: ID!, $first: Int, $after: String) {
    moreClasses(lessonId: $lessonId, first: $first, after: $after) {
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
      nodes {
        id
        date
        time
        startTime
        classType
        seatsRemaining
        bookedAt
        overlapped
        classSize
        category
        credits
        language {
          id
          englishName
          realName
          bannerBackground
        }
        teacher {
          id
          avatar
          givenName
          familyName
        }
        topic {
          id
          title
        }
        chapter {
          name
        }
        level {
          title
        }
        city {
          id
          name
        }
      }
    }
  }
`;

export default GET_MORE_CLASSES;
